const LOGIN_PATH = '/login';
const SIGNUP_PATH = '/sign-up';
const RESET_PASSWORD_PATH = '/reset-password';

const MICROBETTING_URL_SLUG = 'microbetting';
const BETBUILDER_URL_SLUG = 'betbuilder';

type MatchPageView = typeof MICROBETTING_URL_SLUG | typeof BETBUILDER_URL_SLUG;

export { LOGIN_PATH, SIGNUP_PATH, RESET_PASSWORD_PATH, MICROBETTING_URL_SLUG, BETBUILDER_URL_SLUG };
export type { MatchPageView };
